module.exports = require("././angular-route.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-route (bower component)
 ** module id = 157
 ** module chunks = 0
 **/